@if (!scanning && !onMaintenanceApp) {
	<ion-app>
		<ion-router-outlet />
		@if (loader()) {
			<div class="loader-container">
				<div class="loader-main" [style.width]="'60px'" [style.height]="'60px'"></div>
			</div>
		}
	</ion-app>
}

@if (scanning) {
	<div style="position: absolute; top: 20px; right: 20px">
		<ion-icon
			(click)="stopScan()"
			style="position: absolute; top: 20px; right: 20px; font-size: 30px; cursor: pointer; z-index: 99999999"
			color="danger"
			name="close"
		/>
	</div>
}

@if (progressBar && currentEvent) {
	<div class="logo-container">
		<div
			style="
				position: relative;
				width: 100%;
				height: 100%;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
			"
		>
			@if (logo) {
				<img class="logo" [src]="logo" />
			}
			<ion-progress-bar style="margin-top: 20px" [value]="initProgress" />
		</div>
	</div>
}

@if (SUtility.showAlertModal()) {
	<div
		class="tw-fixed tw-left-0 tw-top-0 tw-flex tw-h-full tw-w-full tw-flex-row tw-items-center tw-justify-center tw-bg-[rgba(0,0,0,0.5)]"
	>
		<div
			class="tw-flex tw-h-auto tw-min-w-[300px] tw-max-w-[80vw] tw-flex-col tw-items-start tw-justify-start tw-rounded-lg tw-bg-white"
		>
			<div
				style="border-bottom: 1px solid #e0e0e0"
				class="tw-flex tw-h-[56px] tw-w-full tw-flex-row tw-items-center tw-justify-between tw-rounded-t-lg tw-bg-white tw-px-[20px] tw-py-[10px] tw-font-bold"
			>
				{{ SUtility.alertModalTitle() }}
			</div>
			<div
				class="tw-flex tw-h-auto tw-w-full tw-flex-col tw-items-center tw-justify-center tw-bg-white tw-p-[20px]"
				[innerHTML]="SUtility.alertModalMessage() | safeHtml: 'html'"
			></div>

			<div
				style="border-top: 1px solid #e0e0e0"
				class="tw-flex tw-h-[56px] tw-w-full tw-flex-row tw-items-center tw-justify-end tw-rounded-b-lg tw-bg-white tw-px-[20px] tw-py-[10px]"
			>
				<div
					class="tw-cursor-pointer tw-text-sm tw-font-bold tw-uppercase tw-text-gray-500"
					(click)="
						SUtility.showAlertModal.set(false);
						SUtility.alertModalTitle.set('');
						SUtility.alertModalMessage.set('')
					"
				>
					{{ "buttons.close" | translate }}
				</div>
			</div>
		</div>
	</div>
}

@if (onMaintenanceApp) {
	<div
		style="
			position: fixed;
			z-index: 9999999999;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
			background-color: white;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
		"
	>
		<div
			style="
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				width: 400px;
				height: auto;
				padding: 20px;
			"
		>
			<img style="width: 250px; height: auto; object-fit: cover; margin-bottom: 20px" [src]="logoPlatform" />
			<div style="font-weight: bold; font-size: x-large; text-align: center; width: 100%" class="tw-text-black">
				{{ "labels.on-maintenance" | translate }}
			</div>
		</div>
	</div>
}
